import React, {useEffect} from "react";
import "./SuccessBlock.css"
import {useLocation} from "react-router-dom";


const SuccessBlock = (props) => {
    const successImage = require("../../src/assets/img/success_image.png")
    const location = useLocation() //To received cgurl from homepage


    let redirectUrl = location.state?.id  || "https://www.urduflix.com/sign_in"

        useEffect(() => {
            setTimeout(() => {
                    window.location.replace(redirectUrl)
                }
                , 5000)
        //     console.log("the location.state is", location)
        //     console.log("the redirectUrl is", redirectUrl)
    }, []);


    return (
        <div className="success-container">
            <div className="success-image-container">
                <img className="pulse" src={successImage} alt=""/>
            </div>
            <div className="success-description">
                <p>You will be redirected to the service in 5 seconds</p>
            </div>
        </div>
    )
}

export default SuccessBlock